import type { Backup } from '@/entities/backup';
import type { RequestMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getStackletBackups = (
  id: number,
  params?: RequestMeta,
): Promise<{ backups: Backup[] }> =>
  request({
    url: `/stacklets/${id}/backups/`,
    params,
  });
